import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATUS_LABELS, STATUS_TONE } from '../utils/billingHelpers';

const StatusBadge = ({ status, size = 'md' }) => {
  const { t } = useTranslation();
  const label = STATUS_LABELS[status] ?? status;
  const tone = STATUS_TONE[status] ?? 'neutral';

  return (
    <span className={`bill-badge bill-badge--${tone}${size === 'sm' ? ' bill-badge--sm' : ''}`}>
      {t(label)}
    </span>
  );
};

export default StatusBadge;
